import { ThemeUICSSObject } from '@apia/theme';
import filePicker from './filePicker';
import noSelection from './noSelection';
import primary from './primary';
/* IMPORT HERE */
const trees: ThemeUICSSObject = {
  filePicker,
  primary,
  noSelection,
  /* PREPEND HERE */
};

export default trees;
